var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgArrowButtonRight = function SvgArrowButtonRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    transform: "rotate(-180 20 20)",
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 19.6464C11.4512 19.8417 11.4512 20.1583 11.6464 20.3536L14.8284 23.5355C15.0237 23.7308 15.3403 23.7308 15.5355 23.5355C15.7308 23.3403 15.7308 23.0237 15.5355 22.8284L12.7071 20L15.5355 17.1716C15.7308 16.9763 15.7308 16.6597 15.5355 16.4645C15.3403 16.2692 15.0237 16.2692 14.8284 16.4645L11.6464 19.6464ZM28 19.5L12 19.5V20.5L28 20.5V19.5Z",
    fill: "#595959"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowButtonRight);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMTkuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAyMCAyMCkiIGZpbGw9IndoaXRlIiBzdHJva2U9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS42NDY0IDE5LjY0NjRDMTEuNDUxMiAxOS44NDE3IDExLjQ1MTIgMjAuMTU4MyAxMS42NDY0IDIwLjM1MzZMMTQuODI4NCAyMy41MzU1QzE1LjAyMzcgMjMuNzMwOCAxNS4zNDAzIDIzLjczMDggMTUuNTM1NSAyMy41MzU1QzE1LjczMDggMjMuMzQwMyAxNS43MzA4IDIzLjAyMzcgMTUuNTM1NSAyMi44Mjg0TDEyLjcwNzEgMjBMMTUuNTM1NSAxNy4xNzE2QzE1LjczMDggMTYuOTc2MyAxNS43MzA4IDE2LjY1OTcgMTUuNTM1NSAxNi40NjQ1QzE1LjM0MDMgMTYuMjY5MiAxNS4wMjM3IDE2LjI2OTIgMTQuODI4NCAxNi40NjQ1TDExLjY0NjQgMTkuNjQ2NFpNMjggMTkuNUwxMiAxOS41VjIwLjVMMjggMjAuNVYxOS41WiIgZmlsbD0iIzU5NTk1OSIvPgo8L3N2Zz4K";